import { createAsyncThunk } from '@reduxjs/toolkit';

import { CART_PATH } from 'src/constants/page';
import { ReduxApplicationState } from 'src/redux/combinedReducer';

export const navigateToCart = createAsyncThunk(
  'productInfo/navigateToCart',
  async (_, { getState }) => {
    const state = getState() as ReduxApplicationState;

    if (state.basket.error) {
      return;
    }

    window.location.assign(CART_PATH);
  },
);
